import React from 'react';
import { connect } from 'react-redux';
import { NotificationState } from '../../store/NotificationStore';
import { NotificationProps } from '../../store/state/NotificationState';
import Notification from './Notification/Notification';
import styles from './NotificationsManager.module.css';

interface INotificationsManagerProps {
  notifications?: Array<NotificationProps>
}

const NotificationsManager: React.FC<INotificationsManagerProps> = (props) => {

  const { notifications } = props;

  const hidden = !notifications || notifications.length === 0 ? styles.hidden : '';

  return (<div className={`${hidden} ${styles.wrapper}`}>
    {notifications != null && notifications.map(notification => {
      return <Notification key={notification.id} {...notification} />
    })}
  </div>);
}

const mapStateToProps = function(state: NotificationState): INotificationsManagerProps {
  return {
    notifications: state.notifications
  };
}

export default connect(mapStateToProps)(NotificationsManager);
